module.exports = __webpack_public_path__ + "media/dòot kwăa dòot sáai.58cd8eb4.mp3";